export default __webpack_public_path__ + "static/media/young-man.460ec429.jpg";